import { Box, CircularProgress, Typography } from "@mui/material";

const LoadingState = ({ userName }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="200px"
      gap={2}
    >
      <CircularProgress size={40} thickness={4} />
      <Typography variant="body2" color="text.secondary">
        {`Loading ${userName} break details...`}
      </Typography>
    </Box>
  );
};

export default LoadingState;
